export const getAccessToken = () => {
    let token = localStorage.getItem('okta-token-storage');
    let sessionID = JSON.parse(token).accessToken.value;
    return sessionID;
}